import BridgeApi from '@/lib/api/bridge'

const initialState = () => {
  return {
    logApi: new BridgeApi()
  }
}

const getters = {}

const actions = {
  async log({ state, rootGetters }, { type, data }) {
    const path = window.location?.pathname
    const user = rootGetters['app/getApp'].user

    if (user) {
      await state.logApi.post('/v1/log', { type, user, data, path })
    }
  }
}

const mutations = {}

export default {
  namespaced: true,
  state: initialState(),
  getters,
  actions,
  mutations
}
